import { atom, useRecoilState } from 'recoil';
import { colors } from '~/theme/colors';

export const colorState = atom({
  key: 'color',
  default: 'red',
});

const useColor = () => {
  const [color, setColor] = useRecoilState(colorState);

  const setMainColor = () => {
    setColor(colors.colorMain);
  };

  return {
    color,
    setColor,
    setMainColor,
  };
};

export default useColor;
